"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { useHookFormAction } from "@next-safe-action/adapter-react-hook-form/hooks";
import { sendGTMEvent } from "@next/third-parties/google";
import { toast } from "sonner";

import { Button } from "~/lib/shadcn/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormMessage } from "~/lib/shadcn/components/ui/form";
import { Input } from "~/lib/shadcn/components/ui/input";

import { mailingListAction } from "../actions/mailing-list";
import { MailingListSchema } from "../schemas/mailing-list";

export default function ModalMailingList() {
	const { form, handleSubmitWithAction, resetFormAndAction } = useHookFormAction(
		mailingListAction,
		zodResolver(MailingListSchema),
		{
			actionProps: {
				onError: () => {
					toast.error("Something went wrong!");
				},
				onSuccess: ({ input }) => {
					sendGTMEvent({ event: "MAILING_LIST_SIGN_UP_BOOKING_MODAL", value: input.email });
					toast.success("You have successfully signed up!");
					resetFormAndAction();
				},
			},
			errorMapProps: {},
			formProps: {
				defaultValues: {
					email: "",
					name: "",
				},
			},
		},
	);
	return (
		<Form {...form} key={`mailing-list-${form.formState.submitCount}`}>
			<form className="w-full flex flex-col gap-4 !text-dg-modal-text" onSubmit={handleSubmitWithAction}>
				<FormField
					control={form.control}
					name="name"
					render={({ field }) => (
						<FormItem>
							<FormControl>
								<Input
									className="border-b-dg-modal-text text-dg-modal-text placeholder:text-dg-modal-text"
									placeholder="Name"
									{...field}
								/>
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
				<FormField
					control={form.control}
					name="email"
					render={({ field }) => (
						<FormItem>
							<FormControl>
								<Input
									className="border-b-dg-modal-text text-dg-modal-text placeholder:text-dg-modal-text"
									placeholder="Email"
									{...field}
								/>
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
				<div className="mt-8">
					<Button
						disabled={form.formState.isSubmitting || form.formState.isLoading || form.formState.isValidating}
						type="submit"
						variant={"dg-dark-green"}
					>
						Subscribe
					</Button>
				</div>
			</form>
		</Form>
	);
}
